import { render, staticRenderFns } from "./TileActions.vue?vue&type=template&id=42772988&scoped=true"
import script from "./TileActions.vue?vue&type=script&lang=js"
export * from "./TileActions.vue?vue&type=script&lang=js"
import style0 from "./TileActions.vue?vue&type=style&index=0&id=42772988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42772988",
  null
  
)

export default component.exports